import type { Theme, SxProps } from '@mui/material/styles';

import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Stack, IconButton, Typography, Avatar } from '@mui/material';

import Mail from 'src/assets/social-media-icons/mail.png';
import Twitter from 'src/assets/social-media-icons/twitter.png';
import Youtube from 'src/assets/social-media-icons/youtube.png';
import Facebook from 'src/assets/social-media-icons/facebook.png';
import Iletisim from 'src/assets/social-media-icons/iletisim.png';
import Website from 'src/assets/social-media-icons/websitesi.png';
import Instagram from 'src/assets/social-media-icons/instagram.png';
import { userForOrganizerFunc } from 'src/context/user/userForOrganizer';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  sx?: SxProps<Theme>;
  product: any;
  data?: any;
};

const socialMeidaIcons = {
  facebook: 'eva:facebook-fill',
  twitter: 'eva:twitter-fill',
  instagram: 'mdi:instagram',
  website: 'tabler:world',
  linkedin: 'eva:linkedin-fill',
  youtube: 'mdi:youtube',
};

const socialMediaImages = {
  website: Website,
  mail: Mail,
  instagram: Instagram,
  facebook: Facebook,
  youtube: Youtube,
  twitter: Twitter,
};

const socialMediaURL = {
  facebook: 'https://www.facebook.com/',
  twitter: 'https://x.com/',
  instagram: 'https://www.instagram.com/',
  website: 'https://',
  linkedin: 'https://www.linkedin.com/',
  youtube: 'https://www.youtube.com/',
};

export function ProductSocialInfoForBlog({ product, data }: Props) {
  return (
    <Stack sx={{ py: 3, px: 5 }}>
      <Stack direction="row" alignItems="flex-start" gap={2}>
        <Stack direction="column" alignItems="flex-start" gap={1}>
          {data?.phoneNumber && (
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography
                variant="body1"
                fontFamily="Rubik"
                fontWeight={400}
                sx={{ color: '#CEC3BE' }}
              >
                Telefon Numarası:
              </Typography>
              <Typography
                variant="body1"
                fontFamily="Rubik"
                fontWeight={400}
                sx={{
                  color: 'text.secondary',
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline',
                  },
                }}
                onClick={() => window.open(`tel:${data?.phoneNumber}`)}
              >
                {data?.phoneNumber}
              </Typography>
            </Stack>
          )}

          {data?.phoneNumber2 && (
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography
                variant="body1"
                fontFamily="Rubik"
                fontWeight={400}
                sx={{ color: '#CEC3BE' }}
              >
                Telefon Numarası 2:
              </Typography>
              <Typography
                variant="body1"
                fontFamily="Rubik"
                fontWeight={400}
                sx={{
                  color: 'text.secondary',
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline',
                  },
                }}
                onClick={() => window.open(`tel:${data?.phoneNumber2}`)}
              >
                {data?.phoneNumber2}
              </Typography>
            </Stack>
          )}

          {data?.email && (
            <Stack direction="row" alignItems="center" gap={1} sx={{ ml: -3, mb: 0.5 }}>
              <img src={Mail} alt="email" style={{ width: 20 }} />
              <Typography
                variant="body1"
                fontFamily="Rubik"
                fontWeight={400}
                sx={{ color: 'text.secondary' }}
              >
                {data?.email}
              </Typography>
            </Stack>
          )}

          {data?.socialMedia && Object.keys(data?.socialMedia).length > 0 && (
            <Stack direction="column" alignItems="flex-start" sx={{ ml: -4, mb: 0.5 }}>
              {Object.keys(data?.socialMedia).map(
                (key: string) =>
                  data?.socialMedia[key] && (
                    <IconButton
                      key={key}
                      color="inherit"
                      sx={{ borderRadius: 1 }}
                      onClick={() => {
                        const socialValue = data?.socialMedia[key];
                        let url = '#';

                        if (key && socialValue) {
                          // Eğer değer zaten tam URL ise direkt kullan
                          if (
                            socialValue.startsWith('http://') ||
                            socialValue.startsWith('https://')
                          ) {
                            url = socialValue;
                          } else {
                            // Değilse base URL ile birleştir
                            url = `${socialMediaURL[key as keyof typeof socialMediaURL]}${socialValue}`;
                          }
                        }

                        window.open(url);
                      }}
                    >
                      <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
                        <img
                          src={socialMediaImages[key as keyof typeof socialMediaImages]}
                          alt={key}
                          style={{ width: 20 }}
                        />
                        <Typography
                          variant="body1"
                          fontFamily="Rubik"
                          fontWeight={400}
                          sx={{ color: 'text.secondary' }}
                        >
                          {data?.socialMedia[key]}
                        </Typography>
                      </Stack>
                    </IconButton>
                  )
              )}
            </Stack>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}
